import type { GlobalRole } from '@/services/api/auth'

/** Ordered global-role rank — mirrors the backend. Higher = more privileged. */
const ROLE_RANK: Record<GlobalRole, number> = {
  user: 1,
  admin: 2,
  superadmin: 3,
}

/** True when `role` is at least `min`. Missing role (unauthenticated) is never enough. */
export function hasMinRole(role: GlobalRole | undefined | null, min: GlobalRole): boolean {
  if (!role) return false
  return ROLE_RANK[role] >= ROLE_RANK[min]
}

/** Reaches the admin section (admin or superadmin). */
export function isAdmin(role: GlobalRole | undefined | null): boolean {
  return hasMinRole(role, 'admin')
}

/** Superadmin — the only tier with a case-data bypass / god-features. */
export function isSuperadmin(role: GlobalRole | undefined | null): boolean {
  return role === 'superadmin'
}
